import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["inputProps", "name", "placeholder", "validate"];
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { useField } from 'react-final-form';
import { jsx as _jsx } from "react/jsx-runtime";
export default function FFTextareaControl(_ref) {
  let {
      inputProps = {},
      name,
      placeholder,
      validate = () => {}
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    input,
    meta
  } = useField(name, {
    validate
  });
  return /*#__PURE__*/_jsx(FormControl, Object.assign({}, rest, {
    error: meta.touched && meta.error,
    validationMessage: meta.touched && meta.error,
    children: /*#__PURE__*/_jsx(TextArea, Object.assign({}, input, inputProps, {
      placeholder: placeholder,
      rows: 4
    }))
  }));
}